<template>
  <error-boundary :error-key="['reverseIntegration', 'reverseRestartIntegration']">
    <e-loader v-if="isLoading" class="text-blue mt-10 mx-auto" :size="60" :width="4" />

    <template v-else>
      <c-m-settings v-if="activeStep === 1" />
      <room-categories v-else-if="activeStep === 2" :is-edit-mode="!!isEdit" />
      <service-groups v-else-if="activeStep === 3" />
      <tourists-types v-else-if="activeStep === 4" />
      <placing-variants v-else-if="activeStep === 5" />
      <c-m-side-settings v-else-if="activeStep === 6" :is-edit-mode="!!isEdit" />
    </template>
  </error-boundary>
</template>

<script setup lang="ts">
import { nextTick, toRef } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ELoader } from '@/core/components/ui';
import { useFetch } from '@/core/composables/useFetch';
import ErrorBoundary from '@/parts/errors/components/ErrorBoundary.vue';
import CMSettings from '@/parts/tariffs/components/CM/Reverse/CMSettings.vue';
import CMSideSettings from '@/parts/tariffs/components/CM/Reverse/CMSideSettings.vue';
import PlacingVariants from '@/parts/tariffs/components/CM/Reverse/PlacingVariants.vue';
import RoomCategories from '@/parts/tariffs/components/CM/Reverse/RoomCategories.vue';
import ServiceGroups from '@/parts/tariffs/components/CM/Reverse/ServiceGroups.vue';
import TouristsTypes from '@/parts/tariffs/components/CM/Reverse/TouristsTypes.vue';
import { useReverseIntegrationStore } from '@/parts/tariffs/store/reverse';

const props = defineProps<{
  isEdit: boolean | undefined;
}>();

const $route = useRoute();
const $router = useRouter();

const interactionId = toRef(() => $route.query.interactionId);

const { activeStep, getIntegration, getUncompletedIntegration, checkIsNotStartedIntegration } =
  useReverseIntegrationStore(props.isEdit);

const { isLoading } = useFetch(async () => {
  let isNotStarted = true;
  if (!interactionId.value) {
    const uncompletedIntegration = await getUncompletedIntegration();

    if (!uncompletedIntegration) {
      return;
    }

    const id = uncompletedIntegration.data?.uncompletedReverseInteraction?.interactionId;
    isNotStarted =
      uncompletedIntegration.data?.uncompletedReverseInteraction?.uncompletedInteraction?.isNotStarted ?? true;

    if (id) {
      await $router.push({
        query: {
          interactionId: id,
          manager:
            uncompletedIntegration.data?.uncompletedReverseInteraction?.uncompletedInteraction.channelManagerCode,
        },
      });
    }

    await nextTick();
  } else {
    const isIntegrationIsNotStarted = await checkIsNotStartedIntegration();
    if (isIntegrationIsNotStarted == null) {
      //Integration is not exist
      isNotStarted = false;
    } else
      isNotStarted = isIntegrationIsNotStarted;
  }

  if (!isNotStarted) await getIntegration();
});
</script>

<style scoped lang="scss"></style>
